import {
  Card,
} from "components/ui/card";

interface AuthWindowProps {
  children: React.ReactNode;
}

export const AuthWindow = ({ children }: AuthWindowProps) => {
  return (
    <div className="h-screen flex items-center justify-center">
      <Card className="w-[40rem] -mt-36">
        {children}
      </Card>
    </div>
  );
};
